import { useMemo } from 'react';
// routes
import { paths } from 'src/routes/paths';
// components
import SvgColor from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  // OR
  // <Iconify icon="fluent:mail-24-filled" />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

const ICONS = {
  home: icon('home'),
  games: icon('games'),
  players: icon('players'),
  branches: icon('branches'),
  categories: icon('categories'),
  news: icon('news'),
  job: icon('ic_job'),
  blog: icon('ic_blog'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  tour: icon('ic_tour'),
  order: icon('ic_order'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  product: icon('ic_product'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
};

// ----------------------------------------------------------------------

export function useNavData() {
  const data = useMemo(
    () => [
      // OVERVIEW
      // ----------------------------------------------------------------------
      {
        subheader: 'General',
        items: [
          { title: 'Ana Sayfa', path: paths.dashboard.root, icon: ICONS.home },
          { title: 'Oyunlar', path: paths.dashboard.games, icon: ICONS.games },
          {
            title: 'Kişiler',
            path: paths.dashboard.players,
            icon: ICONS.players,
          },
          {
            title: 'Kişi Tipleri',
            path: paths.dashboard.playertypes,
            icon: ICONS.blank,
          },
          {
            title: 'Sahneler',
            path: paths.dashboard.branches,
            icon: ICONS.branches,
          },
          {
            title: 'Kategoriler',
            path: paths.dashboard.categories,
            icon: ICONS.categories,
          },
          {
            title: 'Aylık Programlar',
            path: paths.dashboard.programs,
            icon: ICONS.calendar,
          },
          
        ],
      },

      {
        subheader: 'Sayfa İçerikleri',
        items: [
          { title: 'Sayfalar', path: paths.dashboard.contents.root ,  icon: ICONS.file,},
          {
            title: 'Haberler',
            path: paths.dashboard.contents.news,
            icon: ICONS.kanban,
          },
          { title: 'Site Menu', path: paths.dashboard.siteManagement.root,  icon: ICONS.calendar,},
          {
            title: 'Slider',
            path: paths.dashboard.siteManagement.slider,
            icon: ICONS.job,
          },
          {
            title: 'Sosyal Hesaplar',
            path: paths.dashboard.siteManagement.social,
            icon: ICONS.players,
          },
        ],
      },

      

     

      //       {
      //   subheader: 'Kullanıcılar',
      //   items: [
      //     {
      //       title: 'Kullanıcılar',
      //       path: paths.dashboard.members.root,
      //       icon: ICONS.user,
      //       children: [
      //         { title: 'Kullanıcılar', path: paths.dashboard.members.root},
      //       ],
      //     },
      //   ],
      // },

      

      

      // MANAGEMENT
      // ----------------------------------------------------------------------
      // {
      //   subheader: 'management',
      //   items: [
      //     {
      //       title: 'user',
      //       path: paths.dashboard.group.root,
      //       icon: ICONS.user,
      //       children: [
      //         { title: 'four', path: paths.dashboard.group.root },
      //         { title: 'five', path: paths.dashboard.group.five },
      //         { title: 'six', path: paths.dashboard.group.six },
      //       ],
      //     },
      //   ],
      // },
    ],
    []
  );

  return data;
}
